import { Chip } from "@mantine/core";
import GridOffRoundedIcon from "@mui/icons-material/GridOffRounded";
import classes from "./NoCalcChip.module.css";

export default function NoCalcChip() {
  return (
    <Chip
      variant="light"
      value="Calc"
      radius="md"
      color="gray"
      size="xs"
      checked={true}
      classNames={{ root: classes.chip }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          gap: "0.4rem",
        }}
      >
        <GridOffRoundedIcon style={{ width: 18, height: 18 }} />
        <span>Non Calc</span>
      </div>
    </Chip>
  );
}
